import { IndustriesPayload } from "../../components/filters/Industries/types";
import { LocationsPayload } from "../../components/filters/Locations/types";
import { SAMConfig } from "../../types/workspace";

export function mergeIndustryPayloads(
  initialIndustries: IndustriesPayload,
  mergingIndustries: SAMConfig["industry"]
): IndustriesPayload {
  return {
    industryIds: [
      ...new Set([
        ...(initialIndustries.industryIds || []),
        ...(mergingIndustries.ids || []),
      ]),
    ],
    sicIds: [],
    naicsIds: [],
    excludedIds: [],
    excludedSicIds: [],
    excludedNaicsIds: [],
  };
}

export function determineIfUnmergeableDataExists(
  selectedIndustries: IndustriesPayload,
  selectedLocations: LocationsPayload
) {
  return (
    selectedIndustries.sicIds.length > 0 ||
    selectedIndustries.naicsIds.length > 0 ||
    selectedLocations.regionIds.length > 0 ||
    selectedLocations.stateIds.length > 0
  );
}
